// Batisur — 25 métiers du BTP les plus recherchés par les particuliers en France
// Chaque métier = page SEO ciblée haute intention "trouver un [metier] à [ville]"
// Prix indicatifs France 2026 (moyennes marché), ajustables par ville via CITY_PRICE_MULTIPLIERS

export const METIER_TYPES = {
  "plombier": {
    slug: "plombier",
    label: "Plombier",
    plural: "Plombiers",
    icon: "Wrench",
    intro: "Le plombier assure l'installation et le dépannage des réseaux d'eau, sanitaires et robinetterie de votre logement.",
    services: ["Installation sanitaires (WC, douche, lavabo)", "Dépannage fuite d'eau", "Détartrage chauffe-eau", "Remplacement colonne d'eau", "Recherche de fuite endoscopique", "Débouchage canalisations"],
    hourlyRate: [45, 70],
    interventionRange: [80, 150],
    exampleProject: { name: "Installation salle de bain complète", price: [3500, 8000] },
    keywords: "plombier, plombier chauffagiste, dépannage plomberie, fuite d'eau, installation sanitaire, prix plombier",
    faqTitle: "Comment choisir un plombier de confiance ?",
    faqBody: "Vérifiez son numéro SIRET, son assurance décennale, ses avis clients et exigez un devis écrit détaillé avant tout paiement.",
  },
  "electricien": {
    slug: "electricien",
    label: "Électricien",
    plural: "Électriciens",
    icon: "Zap",
    intro: "L'électricien installe et met aux normes NFC 15-100 tous les réseaux électriques de votre habitation.",
    services: ["Mise aux normes NFC 15-100", "Installation tableau électrique", "Remplacement prises et interrupteurs", "Éclairage LED", "Domotique connectée", "Dépannage panne électrique"],
    hourlyRate: [40, 65],
    interventionRange: [90, 160],
    exampleProject: { name: "Rénovation électrique complète 80m²", price: [4500, 9500] },
    keywords: "électricien, mise aux normes électrique, tableau électrique, prise électrique, prix électricien",
    faqTitle: "Un électricien Qualifelec est-il indispensable ?",
    faqBody: "La certification Qualifelec garantit la conformité NFC 15-100 et est souvent exigée par les assurances et notaires en cas de revente.",
  },
  "macon": {
    slug: "macon",
    label: "Maçon",
    plural: "Maçons",
    icon: "Bricks",
    intro: "Le maçon réalise le gros œuvre : fondations, murs porteurs, dalles, ouvertures, ravalement et rénovations lourdes.",
    services: ["Ouverture mur porteur", "Construction extension", "Dalle béton", "Ravalement de façade", "Reprise fondations", "Chape et enduit"],
    hourlyRate: [45, 75],
    interventionRange: [120, 200],
    exampleProject: { name: "Extension maison 20m²", price: [22000, 45000] },
    keywords: "maçon, gros œuvre, ouverture mur porteur, extension maison, dalle béton, prix maçon",
    faqTitle: "Le maçon a-t-il besoin d'un permis pour un mur porteur ?",
    faqBody: "Oui, l'ouverture d'un mur porteur nécessite une étude de structure (IPN) et souvent une déclaration préalable de travaux en mairie.",
  },
  "peintre": {
    slug: "peintre",
    label: "Peintre",
    plural: "Peintres en bâtiment",
    icon: "Paintbrush",
    intro: "Le peintre en bâtiment prépare les supports et applique peintures, laques, enduits décoratifs et papiers peints.",
    services: ["Peinture murs intérieurs", "Peinture façade extérieure", "Papier peint", "Enduits décoratifs (béton ciré, tadelakt)", "Laque haute résistance", "Ravalement peinture"],
    hourlyRate: [30, 45],
    interventionRange: [70, 120],
    exampleProject: { name: "Peinture appartement 60m² 2 couches", price: [2500, 4500] },
    keywords: "peintre, peintre en bâtiment, peinture murale, prix peintre, ravalement peinture, enduit décoratif",
    faqTitle: "Combien de couches de peinture prévoir ?",
    faqBody: "Minimum 2 couches sur support préparé. Pour un support neuf ou taché, prévoyez 1 couche d'impression + 2 couches de finition.",
  },
  "carreleur": {
    slug: "carreleur",
    label: "Carreleur",
    plural: "Carreleurs",
    icon: "Grid3x3",
    intro: "Le carreleur pose carrelages muraux et sol : céramique, grès cérame, marbre, mosaïque, faïence.",
    services: ["Carrelage salle de bain", "Carrelage cuisine", "Sols grand format 60×60/80×80", "Mosaïque décorative", "Joints anti-moisissures", "Ragréage support"],
    hourlyRate: [35, 55],
    interventionRange: [90, 160],
    exampleProject: { name: "Carrelage sol + murs SDB 8m²", price: [1600, 3200] },
    keywords: "carreleur, carrelage salle de bain, carrelage cuisine, pose carrelage, prix carreleur au m2",
    faqTitle: "Peut-on carreler sur du carrelage existant ?",
    faqBody: "Oui, à condition que l'ancien soit stable, plan et bien nettoyé. Un primaire d'accrochage est indispensable avant la pose.",
  },
  "chauffagiste": {
    slug: "chauffagiste",
    label: "Chauffagiste",
    plural: "Chauffagistes",
    icon: "Flame",
    intro: "Le chauffagiste installe et entretient chaudières, pompes à chaleur, planchers chauffants et radiateurs.",
    services: ["Pompe à chaleur air/eau ou air/air", "Chaudière condensation gaz", "Plancher chauffant hydraulique", "Radiateurs à inertie", "Entretien annuel chaudière", "Ballon d'eau chaude thermodynamique"],
    hourlyRate: [50, 75],
    interventionRange: [110, 190],
    exampleProject: { name: "Installation PAC air/eau 100m²", price: [10000, 16000] },
    keywords: "chauffagiste, pompe à chaleur, chaudière condensation, plancher chauffant, prix chauffagiste RGE",
    faqTitle: "Faut-il choisir un chauffagiste RGE ?",
    faqBody: "Oui, la qualification RGE (Reconnu Garant de l'Environnement) est obligatoire pour bénéficier de MaPrimeRénov', CEE et éco-PTZ.",
  },
  "couvreur": {
    slug: "couvreur",
    label: "Couvreur",
    plural: "Couvreurs",
    icon: "Home",
    intro: "Le couvreur zingueur pose, rénove et entretient toitures, faîtages, zingueries, gouttières et évacuations pluviales.",
    services: ["Réfection toiture complète", "Remplacement tuiles/ardoises", "Zinguerie et faîtage", "Nettoyage démoussage", "Gouttières PVC ou zinc", "Étanchéité toit terrasse"],
    hourlyRate: [45, 70],
    interventionRange: [150, 250],
    exampleProject: { name: "Réfection toiture 100m² tuiles", price: [8000, 14000] },
    keywords: "couvreur, réfection toiture, zingueur, tuile ardoise, prix couvreur toiture au m2",
    faqTitle: "Combien de temps dure une toiture ?",
    faqBody: "Une toiture en tuile terre cuite dure 40-70 ans, une toiture en ardoise 80-120 ans, une toiture en zinc 60-100 ans selon exposition.",
  },
  "menuisier": {
    slug: "menuisier",
    label: "Menuisier",
    plural: "Menuisiers",
    icon: "Hammer",
    intro: "Le menuisier fabrique et pose portes, fenêtres, escaliers, placards, cuisine sur mesure, terrasse et parquet.",
    services: ["Pose fenêtres double vitrage", "Portes intérieures et blindées", "Escalier sur mesure", "Dressing et placards", "Parquet massif ou stratifié", "Terrasse bois exotique"],
    hourlyRate: [40, 60],
    interventionRange: [95, 170],
    exampleProject: { name: "Remplacement 6 fenêtres double vitrage", price: [4200, 8500] },
    keywords: "menuisier, pose fenêtres, portes intérieures, escalier sur mesure, dressing, parquet, prix menuisier",
    faqTitle: "PVC, alu ou bois pour mes fenêtres ?",
    faqBody: "PVC : le moins cher, isolant, faible entretien. Alu : moderne, ultra-durable, prix moyen. Bois : plus cher, entretien régulier, meilleure isolation.",
  },
  "serrurier": {
    slug: "serrurier",
    label: "Serrurier",
    plural: "Serruriers",
    icon: "Key",
    intro: "Le serrurier ouvre, répare et sécurise portes, serrures, cylindres, coffres et blindages.",
    services: ["Ouverture porte claquée ou fermée à clé", "Remplacement serrure A2P", "Blindage porte", "Installation coffre-fort", "Serrure multipoints", "Portes anti-effraction"],
    hourlyRate: [55, 90],
    interventionRange: [120, 250],
    exampleProject: { name: "Blindage porte + serrure A2P***", price: [1200, 2400] },
    keywords: "serrurier, ouverture porte, changement serrure, blindage porte, serrure A2P, prix serrurier",
    faqTitle: "Comment éviter l'arnaque des serruriers d'urgence ?",
    faqBody: "Exigez un devis AVANT intervention (obligation légale), refusez les serrures cassées 'systématiquement' et privilégiez un artisan Batisur SIRET vérifié.",
  },
  "platrier": {
    slug: "platrier",
    label: "Plâtrier",
    plural: "Plâtriers",
    icon: "Layers",
    intro: "Le plâtrier plaquiste pose cloisons, doublages, faux-plafonds, enduits et isolation intérieure.",
    services: ["Cloisons placo BA13", "Faux-plafond suspendu", "Isolation intérieure ITI", "Enduits lissés ou décoratifs", "Cloisons acoustiques", "Rebouchage fissures"],
    hourlyRate: [35, 55],
    interventionRange: [80, 140],
    exampleProject: { name: "Cloisonnement étage 40m²", price: [3200, 5800] },
    keywords: "plâtrier, plaquiste, cloison placo, faux plafond, isolation intérieure, prix plâtrier",
    faqTitle: "BA13 ou BA18 pour mes cloisons ?",
    faqBody: "BA13 (13mm) suffit pour cloisons standard. BA18 (18mm) est recommandé pour l'acoustique renforcée (chambre, home cinéma).",
  },
  "facadier": {
    slug: "facadier",
    label: "Façadier",
    plural: "Façadiers",
    icon: "Building",
    intro: "Le façadier ravale, isole et rénove les façades extérieures : enduits, ITE, bardage, peinture façade.",
    services: ["Ravalement complet façade", "Isolation thermique extérieure ITE", "Bardage bois ou métal", "Peinture façade hydrofuge", "Rejointoiement pierres", "Nettoyage haute pression"],
    hourlyRate: [45, 70],
    interventionRange: [130, 220],
    exampleProject: { name: "Ravalement façade 120m²", price: [6500, 13500] },
    keywords: "façadier, ravalement façade, ITE, bardage, isolation extérieure, prix ravalement au m2",
    faqTitle: "Le ravalement de façade est-il obligatoire ?",
    faqBody: "Oui, tous les 10 ans dans les communes soumises à l'arrêté préfectoral (loi 1852). La mairie peut vous mettre en demeure.",
  },
  "charpentier": {
    slug: "charpentier",
    label: "Charpentier",
    plural: "Charpentiers",
    icon: "TreePine",
    intro: "Le charpentier fabrique et pose charpentes bois traditionnelles, fermettes industrielles, ossatures et structures porteuses.",
    services: ["Charpente traditionnelle chêne", "Fermettes industrielles", "Ossature bois maison", "Rénovation charpente ancienne", "Traitement anti-termites/insectes", "Modification charpente"],
    hourlyRate: [50, 75],
    interventionRange: [140, 220],
    exampleProject: { name: "Charpente traditionnelle 100m²", price: [12000, 22000] },
    keywords: "charpentier, charpente bois, fermette, ossature bois, prix charpente au m2, rénovation charpente",
    faqTitle: "Quand faire traiter sa charpente ?",
    faqBody: "Traitement curatif tous les 10 ans en zone à risque, ou dès apparition de sciure, galeries ou insectes xylophages (capricornes, vrillettes).",
  },
  "vitrier": {
    slug: "vitrier",
    label: "Vitrier",
    plural: "Vitriers",
    icon: "Square",
    intro: "Le vitrier remplace vitrages, miroirs, vérandas, verrières et sécurise les ouvertures en verre.",
    services: ["Remplacement vitre cassée", "Double vitrage isolant", "Miroir sur mesure", "Verrière intérieure style atelier", "Vitrage feuilleté anti-effraction", "Garde-corps verre"],
    hourlyRate: [45, 70],
    interventionRange: [90, 160],
    exampleProject: { name: "Verrière atelier 3m", price: [1800, 4200] },
    keywords: "vitrier, vitrerie, remplacement vitre, verrière atelier, double vitrage, prix vitrier",
    faqTitle: "Combien coûte un remplacement de vitre en urgence ?",
    faqBody: "80-250€ selon la surface et l'accès. Le vitrage feuilleté sécurité (retardateur d'effraction) coûte 30-50% de plus qu'un vitrage standard.",
  },
  "cuisiniste": {
    slug: "cuisiniste",
    label: "Cuisiniste",
    plural: "Cuisinistes",
    icon: "UtensilsCrossed",
    intro: "Le cuisiniste conçoit, fournit et pose votre cuisine équipée : plans, meubles, plans de travail, électroménager intégré.",
    services: ["Conception 3D personnalisée", "Fourniture cuisine équipée", "Pose et raccordements", "Plan de travail sur mesure (quartz, granit)", "Îlot central", "Électroménager encastrable"],
    hourlyRate: [45, 70],
    interventionRange: [130, 230],
    exampleProject: { name: "Cuisine équipée 10m² haut de gamme", price: [12000, 30000] },
    keywords: "cuisiniste, cuisine équipée sur mesure, îlot central, plan de travail quartz, prix cuisine équipée",
    faqTitle: "Combien coûte une cuisine équipée en 2026 ?",
    faqBody: "Entrée de gamme : 3000-6000€. Milieu de gamme : 7000-15000€. Haut de gamme sur mesure : 15000-40000€ pose incluse.",
  },
  "paysagiste": {
    slug: "paysagiste",
    label: "Paysagiste",
    plural: "Paysagistes",
    icon: "Trees",
    intro: "Le paysagiste conçoit et réalise jardins, terrasses, allées, piscines paysagées, arrosage automatique et clôtures végétales.",
    services: ["Création jardin paysager", "Terrasse bois ou dallage", "Allées et bordures", "Élagage et taille", "Arrosage automatique", "Clôtures végétales et bassins"],
    hourlyRate: [40, 65],
    interventionRange: [110, 190],
    exampleProject: { name: "Création jardin 200m² clé en main", price: [8000, 18000] },
    keywords: "paysagiste, aménagement jardin, terrasse bois, arrosage automatique, prix paysagiste, création jardin",
    faqTitle: "Faut-il un permis pour aménager son jardin ?",
    faqBody: "Non pour de simples plantations. Oui pour terrasse >20m², abri jardin >5m² ou piscine >10m² (déclaration préalable en mairie).",
  },
  "installateur-poele-bois": {
    slug: "installateur-poele-bois",
    label: "Installateur poêle à bois",
    plural: "Installateurs poêle à bois",
    icon: "Flame",
    intro: "L'installateur poêle à bois RGE conseille, pose et raccorde poêles à bûches, granulés, cheminées et inserts.",
    services: ["Pose poêle à bûches", "Pose poêle à granulés (pellets)", "Insert cheminée fonte", "Conduit de fumée inox", "Certificat de conformité", "Ramonage annuel"],
    hourlyRate: [50, 75],
    interventionRange: [130, 220],
    exampleProject: { name: "Poêle à granulés + conduit", price: [3500, 6500] },
    keywords: "installateur poêle à bois, poêle à granulés, insert cheminée, conduit fumée, prix poêle installé RGE",
    faqTitle: "MaPrimeRénov' couvre-t-elle un poêle à granulés ?",
    faqBody: "Oui, jusqu'à 2500€ selon revenus. Condition : installation par un artisan RGE Qualibois + performance ≥ 75% de rendement.",
  },
  "installateur-salle-de-bain": {
    slug: "installateur-salle-de-bain",
    label: "Installateur salle de bain",
    plural: "Installateurs salle de bain",
    icon: "Bath",
    intro: "L'installateur salle de bain coordonne plomberie, carrelage, électricité et pose des équipements sanitaires clé en main.",
    services: ["Rénovation SDB clé en main", "Douche italienne", "Baignoire îlot ou d'angle", "Meuble vasque suspendu", "Robinetterie thermostatique", "Sèche-serviette électrique"],
    hourlyRate: [45, 70],
    interventionRange: [110, 200],
    exampleProject: { name: "Salle de bain complète 6m²", price: [5500, 12000] },
    keywords: "installateur salle de bain, rénovation SDB, douche italienne, baignoire îlot, prix rénovation salle de bain",
    faqTitle: "Combien coûte une salle de bain complète ?",
    faqBody: "5000-8000€ en entrée de gamme, 8000-15000€ en milieu de gamme, 15000-30000€ en haut de gamme selon surface et matériaux.",
  },
  "installateur-veranda": {
    slug: "installateur-veranda",
    label: "Installateur véranda",
    plural: "Installateurs véranda",
    icon: "Warehouse",
    intro: "L'installateur véranda conçoit, fabrique et pose vérandas alu, verre, bois et pergolas bioclimatiques.",
    services: ["Véranda alu vitrée", "Véranda toit polycarbonate", "Extension véranda 4 saisons", "Pergola bioclimatique", "Rideaux verre coulissants", "Chauffage plancher véranda"],
    hourlyRate: [50, 75],
    interventionRange: [150, 250],
    exampleProject: { name: "Véranda alu 15m² isolée", price: [18000, 32000] },
    keywords: "installateur véranda, véranda alu, pergola bioclimatique, extension véranda, prix véranda au m2",
    faqTitle: "Faut-il un permis de construire pour une véranda ?",
    faqBody: "Déclaration préalable si surface ≤ 40m². Permis de construire au-delà, ou si votre commune est en zone protégée.",
  },
  "installateur-alarme": {
    slug: "installateur-alarme",
    label: "Installateur alarme",
    plural: "Installateurs alarme",
    icon: "Bell",
    intro: "L'installateur alarme sécurise votre domicile avec systèmes anti-intrusion, vidéosurveillance et télésurveillance certifiés.",
    services: ["Alarme filaire ou sans fil", "Vidéosurveillance HD", "Détecteurs mouvement/ouverture", "Sirène extérieure", "Télésurveillance 24/7", "Interphone connecté"],
    hourlyRate: [50, 80],
    interventionRange: [130, 220],
    exampleProject: { name: "Alarme + 4 caméras HD", price: [1500, 3200] },
    keywords: "installateur alarme, vidéosurveillance, télésurveillance, sécurité domicile, prix alarme installée",
    faqTitle: "Une alarme réduit-elle vraiment le risque de cambriolage ?",
    faqBody: "Oui, selon la Gendarmerie Nationale, un domicile équipé d'une alarme visible dissuade 95% des cambrioleurs occasionnels.",
  },
  "installateur-portail-motorise": {
    slug: "installateur-portail-motorise",
    label: "Installateur portail motorisé",
    plural: "Installateurs portail motorisé",
    icon: "DoorClosed",
    intro: "L'installateur portail motorisé pose et automatise portails battants, coulissants, portes de garage et interphones.",
    services: ["Portail coulissant motorisé", "Portail battant 2 vantaux", "Porte de garage sectionnelle", "Motorisation solaire", "Interphone vidéo", "Barrière levante"],
    hourlyRate: [45, 70],
    interventionRange: [110, 190],
    exampleProject: { name: "Portail coulissant alu + motorisation", price: [3200, 6800] },
    keywords: "installateur portail motorisé, portail coulissant, porte de garage automatique, motorisation, prix portail motorisé",
    faqTitle: "Motorisation battante ou coulissante ?",
    faqBody: "Battante : moins chère, dégagement devant portail requis. Coulissante : plus fiable, idéale espace restreint, coût +20-30%.",
  },
  "depanneur-electromenager": {
    slug: "depanneur-electromenager",
    label: "Dépanneur électroménager",
    plural: "Dépanneurs électroménager",
    icon: "Wrench",
    intro: "Le dépanneur électroménager répare lave-linge, sèche-linge, lave-vaisselle, réfrigérateur, four et hotte de toutes marques.",
    services: ["Réparation lave-linge", "Réparation sèche-linge", "Dépannage lave-vaisselle", "Réparation réfrigérateur/congélateur", "Four et plaques induction", "Diagnostic électronique"],
    hourlyRate: [45, 75],
    interventionRange: [90, 180],
    exampleProject: { name: "Diagnostic + réparation lave-linge", price: [120, 380] },
    keywords: "dépanneur électroménager, réparation lave-linge, réparation lave-vaisselle, dépannage four, prix dépannage électroménager",
    faqTitle: "Réparer ou remplacer un électroménager ?",
    faqBody: "Règle des 50% : si la réparation coûte plus de 50% du prix d'un neuf équivalent, envisagez le remplacement (impact écologique inclus).",
  },
  "climaticien": {
    slug: "climaticien",
    label: "Climaticien",
    plural: "Climaticiens",
    icon: "Wind",
    intro: "Le climaticien installe, entretient et dépanne systèmes de climatisation réversible, split, VMC double flux et pompes à chaleur air/air.",
    services: ["Climatisation split réversible", "Multi-split 2 à 5 pièces", "PAC air/air réversible", "VMC double flux", "Entretien annuel obligatoire (F-Gaz)", "Diagnostic fuite fluide"],
    hourlyRate: [50, 80],
    interventionRange: [130, 220],
    exampleProject: { name: "Climatisation multi-split 3 pièces", price: [4500, 8500] },
    keywords: "climaticien, climatisation réversible, multi-split, PAC air-air, VMC double flux, prix climatisation installée",
    faqTitle: "Faut-il un climaticien attestation F-Gaz ?",
    faqBody: "Oui, obligatoire depuis 2011 pour manipuler les fluides frigorigènes (R32, R410A). Sans cette attestation, l'installation est illégale.",
  },
  "isolateur-thermique": {
    slug: "isolateur-thermique",
    label: "Isolateur thermique",
    plural: "Isolateurs thermiques",
    icon: "Snowflake",
    intro: "L'isolateur thermique RGE isole combles, murs, planchers et façades pour améliorer votre DPE et réduire vos factures d'énergie.",
    services: ["Isolation combles perdus", "Isolation combles aménagés (ITI/ITE)", "Isolation par l'extérieur (ITE)", "Isolation plancher bas", "Cave et sous-sol", "Bilan thermique complet"],
    hourlyRate: [40, 60],
    interventionRange: [100, 180],
    exampleProject: { name: "Isolation combles 80m² soufflage laine", price: [2000, 4500] },
    keywords: "isolateur thermique, isolation combles, ITE, isolation extérieure, MaPrimeRénov, prix isolation RGE",
    faqTitle: "MaPrimeRénov' couvre-t-elle l'isolation ?",
    faqBody: "Oui, jusqu'à 100€/m² pour ITE et 25€/m² pour combles perdus (revenus modestes). Obligation : artisan RGE Qualibat + résistance thermique R conforme.",
  },
  "terrassier": {
    slug: "terrassier",
    label: "Terrassier",
    plural: "Terrassiers",
    icon: "Shovel",
    intro: "Le terrassier prépare vos terrains : fouilles fondations, viabilisation, tranchées, remblais, drainage et évacuation gravats.",
    services: ["Terrassement fondations maison", "Viabilisation terrain (eau, EDF, télécom)", "Tranchée piscine ou fosse", "Nivellement et compactage", "Drainage périmétrique", "Évacuation gravats en décharge"],
    hourlyRate: [45, 75],
    interventionRange: [140, 240],
    exampleProject: { name: "Terrassement maison 100m² + viabilisation", price: [7500, 14000] },
    keywords: "terrassier, terrassement, viabilisation terrain, fouilles fondations, drainage, prix terrassier",
    faqTitle: "Faut-il un permis pour terrasser son jardin ?",
    faqBody: "Aucune autorisation si <100m³ déblais/remblais. Au-delà, déclaration préalable (loi ENE). Toujours vérifier les réseaux enterrés (DT-DICT).",
  },
  "charpentier-metallique": {
    slug: "charpentier-metallique",
    label: "Charpentier métallique",
    plural: "Charpentiers métalliques",
    icon: "Wrench",
    intro: "Le charpentier métallique conçoit et pose structures acier, hangars, mezzanines, portails et escaliers métalliques industriels.",
    services: ["Structure acier hangar", "Mezzanine acier appartement", "Escalier métallique design", "Portail ferronnerie sur mesure", "Passerelle industrielle", "Garde-corps inox extérieur"],
    hourlyRate: [50, 80],
    interventionRange: [140, 240],
    exampleProject: { name: "Mezzanine acier 15m² sur mesure", price: [5500, 11000] },
    keywords: "charpentier métallique, structure acier, mezzanine, escalier métal, ferronnerie, prix charpente métallique",
    faqTitle: "Combien pèse une charpente métallique ?",
    faqBody: "En moyenne 25-45 kg/m² pour un bâtiment courant, vs 40-70 kg/m² pour une charpente bois. Idéale pour grandes portées sans appui.",
  },
};

export const METIER_LIST = Object.values(METIER_TYPES);

// City price multipliers : Paris >> régions, Nice/Bordeaux ~ moyennes hautes, Nantes/Rennes ~ neutres
export const CITY_PRICE_MULTIPLIERS = {
  "paris": 1.35,
  "lyon": 1.15,
  "marseille": 1.10,
  "bordeaux": 1.12,
  "toulouse": 1.05,
  "nantes": 1.05,
  "lille": 1.00,
  "strasbourg": 1.05,
  "rennes": 1.00,
  "montpellier": 1.05,
  "nice": 1.20,
  "grenoble": 1.05,
  "angers": 0.95,
  "rouen": 0.98,
  "reims": 0.98,
  "le-havre": 0.95,
  "toulon": 1.08,
};

export function getCityMultiplier(citySlug) {
  return CITY_PRICE_MULTIPLIERS[citySlug] || 1.0;
}

export function priceWithMult(range, mult) {
  return [Math.round(range[0] * mult), Math.round(range[1] * mult)];
}
